module.exports = __webpack_public_path__ + "img/DINPro-Bold.f5c1d00b.svg";